/* eslint-disable @typescript-eslint/no-magic-numbers */
import { range } from 'ramda';

const ONE_HUNDRED = 100;

interface ScaleHeight {
  scale: number;
  height: number;
}

export const getScaleToHeightMap = (node: HTMLElement): ScaleHeight[] => {
  const baseWidth = node.getBoundingClientRect().width;

  const clonedNode = node.cloneNode(true) as HTMLElement;

  clonedNode.style.position = 'fixed';
  clonedNode.style.visibility = 'hidden';
  document.body.appendChild(clonedNode);

  const scales = range(5, 101).map(scaleItem => {
    const scale = scaleItem / ONE_HUNDRED;

    const width = 1 / scale;
    clonedNode.style.width = `${Math.round(baseWidth * width)}px`;
    clonedNode.style.transform = `scale(${scale})`;

    const rect = clonedNode.getBoundingClientRect();

    return {
      scale,
      height: rect.height
    };
  });
  document.body.removeChild(clonedNode);
  return scales.reverse();
};
